import { useRegisterComponent } from '../../../orchestrator';
import { useAppSelector } from '../../../../stores/redux.store';

/**
 * Returns whether the user already has passkeys enrolled.
 * Used to conditionally show/hide passkey-related content.
 */
export const useHasPasskeys = () => {
  useRegisterComponent(useHasPasskeys.name);

  const hasPasskeys = useAppSelector(state => state.mfaPromote.hasPasskeys);

  return { hasPasskeys };
};
